import { Shell } from "@/components/Shell";
import { VoiceAnnouncer } from "@/components/VoiceAnnouncer";
import { LayoutDashboard, ArrowDownToLine, ArrowUpFromLine, History, ShieldAlert } from "lucide-react";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/dashboard/deposit", label: "Deposit", icon: ArrowDownToLine },
  { to: "/dashboard/withdraw", label: "Withdraw", icon: ArrowUpFromLine },
  { to: "/dashboard/history", label: "History", icon: History },
  { to: "/dashboard/disputes", label: "Disputes", icon: ShieldAlert },
];

export default function UserLayout() {
  return (
    <>
      <Shell items={items} tag="My Wallet" />
      <VoiceAnnouncer />
    </>
  );
}
